<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="3%")
          span #
        th.text-left(width="7%")
          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
        th.text-left(width="7%")
          span(:title="$t('ui.rescue_id')") {{ $t('ui.rescue_id') }}
        th.text-left(width="7%")
          span(:title="$t('ui.rescue_name')") {{ $t('ui.rescue_name') }}
        th.text-left(width="7%")
          span(:title="$t('ui.cycle')") {{ $t('ui.cycle') }}
        th.text-left(width="7%")
          span(:title="$t('ui.start_date')") {{ $t('ui.start_date') }}
        th.text-left(width="7%")
          span(:title="$t('ui.end_date')") {{ $t('ui.end_date') }}
        th.text-right(width="7%")
          span(:title="$t('ui.min_lose')") {{ $t('ui.min_lose') }}
        th.text-right(width="8%")
          span(:title="$t('ui.total_winlose')") {{ $t('ui.total_winlose') }}
        th.text-right(width="5%")
          span(:title="$t('ui.rate')") {{ $t('ui.rate') }}
        th.text-right(width="7%")
          span(:title="$t('ui.max_payout')") {{ $t('ui.max_payout') }}
        th.text-right(width="7%")
          span(:title="$t('ui.actual_amount')") {{ $t('ui.actual_amount') }}
        th.text-right(width="7%")
          span(:title="$t('ui.rounded_amount')") {{ $t('ui.rounded_amount') }}
        th(width="8%")
          span(:title="$t('ui.payout_method')") {{ $t('ui.payout_method') }}
        th(width="8%")
          span(:title="$t('ui.inbox_id')") {{ $t('ui.inbox_id') }}
        th.text-center(width="7%")
          span(:title="$t('ui.target_group')") {{ $t('ui.target_group') }}
        th.text-right(width="5%")
          span(:title="$t('ui.member_vip_id')") {{ $t('ui.vip_id') }}
        th.text-right(width="5%")
          span(:title="$t('ui.vip_list')") {{ $t('ui.vip_list') }}
        th.text-center(width="5%")
          span(:title="$t('ui.status')") {{ $t('ui.status') }}
        th.text-right(width="7%")
          span(:title="$t('ui.date')") {{ $t('ui.date') }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(:colspan="20").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td.text-left
          span(:title="item.account_id") {{ item.account_id }}
        td.text-left
          span(:title="item.rescue_id") {{ item.rescue_id }}
        td.text-left
          span(:title="item.rescue_name") {{ item.rescue_name }}
        td.text-left
          span(:title="item.rescue_cycle") {{ item.rescue_cycle }}
        td.text-left
          span(:title="$moment(item.start_date).format('YYYY-MM-DD')") {{ $moment(item.start_date).format('YYYY-MM-DD') }}
        td.text-left
          span(:title="$moment(item.end_date).format('YYYY-MM-DD')") {{ $moment(item.end_date).format('YYYY-MM-DD') }}
        td.text-right
          span.font-weight-bold(:title="$n(item.min_lose, 'currency')" :class="$helpers.fontClassName(item.min_lose)") {{ $n(item.min_lose, 'currency') }}
        td.text-right
          span(:title="$n(item.total_winlose, 'currency')") {{ $n(item.total_winlose, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(item.rescue_rate, 'currency')" :class="$helpers.fontClassName(item.rescue_rate)") {{ $n(item.rescue_rate, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(item.max_payout, 'currency')" :class="$helpers.fontClassName(item.max_payout)") {{ $n(item.max_payout, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(item.actual_amount, 'currency')" :class="$helpers.fontClassName(item.actual_amount)") {{ $n(item.actual_amount, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(item.rounded_amount, 'currency')" :class="$helpers.fontClassName(item.rounded_amount)") {{ $n(item.rounded_amount, 'currency') }}
        td
          span.d-block(:title="item.payout_method") {{ item.payout_method }}
        td
          span(:title="item.inbox_id") {{ item.inbox_id }}
        td.text-center
          span(:title="item.target_group") {{ item.target_group }}
        td.text-left
          span(:title="item.member_vip_id") {{ item.member_vip_id }}
        td.text-left
          span(:title="item.vip_list") {{ item.vip_list }}
        td.text-center
          span.font-weight-bold.badge.badge-info(v-if="item.action_status.trim().toUpperCase() == 'SKIP'") {{ item.action_status.trim().toUpperCase() }}
          span.font-weight-bold.badge.badge-success(v-if="item.action_status.trim().toUpperCase() == 'SUCCESS'") {{ item.action_status.trim().toUpperCase() }}
        td.text-right
          span(:title="$moment(item.action_date).format('YYYY-MM-DD HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD HH:mm:ss') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  watch: {
    tbl(newValue, oldValue) {
      //this.getTotal();
    },
  },
  mounted: function() {
    //this.getTotal();
  },
  methods: {
    clearTotal() {
    },
    getTotal: function() {
      //this.clearTotal();
    }
  }
};
</script>
